import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import EventsPage from './pages/EventsPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminMenus from './pages/AdminMenus';
import AdminReservations from './pages/AdminReservations';
import AdminContacts from './pages/AdminContacts';
import AdminEvents from './pages/AdminEvents';
import AdminCMS from './pages/AdminCMS';
import AdminCMSWeeklyMenu from './pages/AdminCMSWeeklyMenu';
import AdminCMSMenuSource from './pages/AdminCMSMenuSource';
import AdminCMSEveningMenu from './pages/AdminCMSEveningMenu';
import AdminCMSMenuThermes from './pages/AdminCMSMenuThermes';
import AdminCMSRestaurantInfo from './pages/AdminCMSRestaurantInfo';
import AdminFeedbackSettings from './pages/AdminFeedbackSettings';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/evenements" element={<EventsPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/menus" element={<AdminMenus />} />
          <Route path="/admin/reservations" element={<AdminReservations />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/admin/feedback-settings" element={<AdminFeedbackSettings />} />
          <Route path="/admin/cms" element={<AdminCMS />} />
          <Route path="/admin/cms/weekly-menu" element={<AdminCMSWeeklyMenu />} />
          <Route path="/admin/cms/menu-source" element={<AdminCMSMenuSource />} />
          <Route path="/admin/cms/evening-menu" element={<AdminCMSEveningMenu />} />
          <Route path="/admin/cms/menu-thermes" element={<AdminCMSMenuThermes />} />
          <Route path="/admin/cms/restaurant-info" element={<AdminCMSRestaurantInfo />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;